import type { LogicNodeDefinition } from '../LogicNodeDefinition';
import { z } from 'zod';

export const DebugTimerStateSchema = z.object({
  label: z.string().trim().min(1).max(80).default('default'),
  lastInput: z.boolean().default(false),
});
export type DebugTimerState = z.infer<typeof DebugTimerStateSchema>;

function definition(type: string): LogicNodeDefinition<DebugTimerState> {
  return {
    type,
    configurationKeys: ['label'],
    stateSchema: DebugTimerStateSchema,
    createDefaultState: () => ({ label: 'default', lastInput: false }),
    needsInputSync: (input, state) => input !== state.lastInput,
    process: (input, state) => {
      state.lastInput = input;
      return false;
    },
  };
}
export const DebugTimerStartNode = definition('DEBUG_TIMER_START');
export const DebugTimerEndNode = definition('DEBUG_TIMER_END');
